import type { Step } from '../interfaces/step';

export const initialSteps: Step = {
	title: 'Informations utilisateur',
	dataTestId: 'userStep',
	required: true,
	updating: false,
	validated: false,
};

export const teletransmissionStep: Step = {
	title: 'Informations télétransmission',
	dataTestId: 'teletransmissionStep',
	required: true,
	updating: false,
	validated: false,
};

export const parapheurStep: Step = {
	title: 'Informations parapheur',
	dataTestId: 'parapheurStep',
	required: true,
	updating: false,
	validated: false,
};

export const STEP_UTILISATEUR = 0;
export const STEP_PARAPHEUR = 1;
export const STEP_TELETRANSMISSION = 2;
